<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 488.928 488.928" style="enable-background:new 0 0 488.928 488.928;" xml:space="preserve">
<g>
	<g>
		<path d="M484.312,401.568l-115.8-54.04c-0.16-0.184-0.36-0.336-0.544-0.504c-0.2-0.184-0.4-0.36-0.616-0.528
			c-0.144-0.112-0.264-0.256-0.416-0.36c-0.264-0.176-0.552-0.272-0.832-0.408c-0.152-0.08-0.272-0.192-0.424-0.264l-57.368-24.584
			l-91.288-39.128l25.208-8.4l61.24,25.344h0.008l167.992,69.512c0.976,0.408,2.016,0.608,3.056,0.608
			c1.56,0,3.112-0.456,4.448-1.344c2.216-1.488,3.552-3.984,3.552-6.656v-256c0-3.24-1.952-6.16-4.936-7.392l-64-26.488h-0.008
			L245.592,1.424C245,1.176,244.384,1.016,243.76,0.92c-0.016,0-0.024-0.008-0.04-0.008c-1.2-0.176-2.416-0.056-3.568,0.304
			c-0.048,0.016-0.104,0-0.152,0.016l-240,80l5.064,15.176l229.464-76.496v239.136l-32,10.664v-68.896c0-2.536-1.2-4.92-3.232-6.432
			c-2.04-1.504-4.672-1.968-7.096-1.224l-184,56c-3.368,1.024-5.672,4.136-5.672,7.656v80v48c0,3.08,1.768,5.888,4.544,7.216
			l85.104,40.704l-36.96,16.8c-2.84,1.28-4.664,4.104-4.688,7.216s1.76,5.96,4.576,7.296l48.04,22.76l6.84-14.464L77.52,456.968
			l33.488-15.216l80.056,38.288c0.232,0.112,0.48,0.152,0.712,0.232c0.264,0.096,0.52,0.192,0.792,0.264
			c0.464,0.12,0.936,0.176,1.408,0.208c0.192,0.008,0.368,0.072,0.552,0.072c0.072,0,0.136-0.024,0.2-0.032
			c0.496-0.016,0.976-0.104,1.456-0.208c0.208-0.048,0.424-0.056,0.632-0.12c0.208-0.064,0.408-0.168,0.616-0.248
			c0.08-0.032,0.16-0.016,0.24-0.048l168-72c2.952-1.248,4.856-4.144,4.856-7.344v-34.688l91.272,42.6l-142.584,64.808l6.624,14.56
			l158.4-72c2.84-1.288,4.672-4.12,4.688-7.24C488.944,405.736,487.136,402.888,484.312,401.568z M418.528,288.816v-80v-32V90.304
			l48,19.856v238.68l-48-19.864V288.816z M402.528,322.36l-74.272-30.736l41.704-10.416l32.568,13.024V322.36z M346.528,270.568
			v-63.504l16-4v63.504L346.528,270.568z M402.528,277l-24-9.6v-62.768l12,4.8l12,4.8V277z M402.528,197l-12-4.8l-12-4.8v-14.768
			l24,9.6V197z M314.528,47.264l88,36.416V165l-24-9.6v-26.584h-16v25.752l-48,12V47.264z M314.528,183.064l48-12v15.504l-48,12
			V183.064z M314.528,215.064l16-4v63.504l-16,4V215.064z M250.528,20.784l48,19.864v136.168v32v70.512l-48-19.864V20.784z
			 M194.064,289.32l90.976,38.992l-142.912,62.576L32.544,338.472l12.304-3.744l48.008-14.608l20.448-6.224l11.552-3.512h0.008
			l48-14.608L194.064,289.32z M50.528,316.28v-21.696l32-10.664v22.624L50.528,316.28z M130.528,291.936v-21.352l32-10.664v22.272
			l-13.336,4.056L130.528,291.936z M18.528,262.744l168-51.128v63.28l-8,2.432v-28.512c0-2.568-1.232-4.992-3.32-6.488
			c-2.104-1.512-4.784-1.912-7.208-1.104l-48,16c-3.272,1.096-5.472,4.144-5.472,7.592V296.8l-16,4.872v-28.856
			c0-2.568-1.232-4.984-3.32-6.488c-2.096-1.504-4.776-1.912-7.208-1.104l-48,16c-3.272,1.096-5.472,4.144-5.472,7.592v32.336
			l-16,4.864V262.744z M186.528,460.12l-71.968-34.424h-0.008l-96.024-45.92v-30.264l168,80.344V460.12z M194.712,416.032
			L161.184,400l144.008-63.048l37.024,15.864L194.712,416.032z M354.528,395.544l-152,65.144v-30.592l152-65.144V395.544z"/>
	</g>
</g>
<g>
	<g>
		<path d="M175.208,66.328c-2.104-1.504-4.784-1.92-7.208-1.104l-144,48c-3.272,1.096-5.472,4.144-5.472,7.592v96
			c0,2.568,1.232,4.984,3.32,6.488c1.384,1,3.024,1.512,4.68,1.512c0.848,0,1.704-0.136,2.528-0.408l144-48
			c3.272-1.096,5.472-4.144,5.472-7.592v-96C178.528,70.248,177.296,67.832,175.208,66.328z M162.528,163.056l-128,42.664v-79.136
			l128-42.664V163.056z"/>
	</g>
</g>
<g>
	<g>
		<path d="M132.864,115.152l-28.504,28.512l-19.304-6.44c-2.344-0.768-4.912-0.432-6.968,0.936l-24,16l8.872,13.312l20.744-13.832
			l20.288,6.76c2.872,0.96,6.048,0.2,8.184-1.936l32-32L132.864,115.152z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
